// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"59a5a924","446":"bc40a9f3"}[chunkId] + ".chunk.js";
};